import PropTypes from 'prop-types'
import styles from './ProposalCompletion.css'
import { useSilentPage } from '../../../../context/silentPageContext'
import { unbindBeforeunload } from '../BeforeUnload'
import ActionLink from '../../../Listing/QueryPage/ActionLink/ActionLink'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'

const TitleSubTitle = ({ title, subTitle, proposalId, proposalType, withHint }) => (
  <div className={styles.titleSection}>
    <h1 data-role='completion-title'>{title}</h1>
    <h2 data-role='completion-sub-title'>
      {subTitle}
      <ActionLink
        targetURL={`/proposal/${proposalType}/overview?id=${proposalId}`}
      >
        {proposalId}
      </ActionLink>
      {withHint && '\xa0(點擊可檢視提案執行狀態)'}
    </h2>
  </div>
)

const ProposalCompletion = props => {
  const {
    imgUrl = `${CDN}/img/img_proposal_success.svg`,
    subTitle,
    title,
    proposalId,
    proposalType,
    children = null,
    withHint = true
  } = props

  const { setSilentPageTo } = useSilentPage()
  setSilentPageTo(true)
  unbindBeforeunload()

  return (
    <div
      data-role='proposal-completion'
      className={styles.ProposalCompletion}
    >
      <div className={styles.imgContainer}>
        <img src={imgUrl} />
      </div>
      <TitleSubTitle
        title={title}
        subTitle={subTitle}
        proposalId={proposalId}
        proposalType={proposalType}
        withHint={withHint}
      />
      {children}

    </div>
  )
}

ProposalCompletion.propTypes = {
  imgUrl: PropTypes.string,
  subTitle: PropTypes.string,
  title: PropTypes.string
}

export default ProposalCompletion
